<template>
  <div class="rotating-headers">
    <h2
      class="rotating-headers__header"
      v-for="(header,i) in headers"
      :class="activeHeader === i ? 'rotating-headers__header--active' : 'rotating-headers__header--inactive'"
      :key="header">
      {{ header }}
    </h2>
  </div>
</template>

<script>
export default {
  name: "RotatingHeader",
  props: {
    headers: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      activeHeader: 0,
      interval: null
    };
  },
  mounted() {
    const rotateHighlight = () => {
      this.activeHeader++;

      if (this.activeHeader >= this.headers.length) {
        this.activeHeader = 0;
      }
    };

    rotateHighlight();

    this.interval  = setInterval(()=> {
      rotateHighlight();
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }

};
</script>

<style lang="scss" scoped>
.rotating-headers {

  &__header {
    @include font-style((xs: h3, m: h2));

    &--inactive {
      color: $mid-grey;
    }

    &--active {
      color: $midnight;

      transition: color 0.1s ease-out;
    }

    &:not(:last-of-type) {
      margin-bottom: $spacing-8;
    }
  }
}
</style>
